import React, { useContext } from 'react';
import * as S from './ThemeSwitchButton.style';
import { Sun, Moon } from 'react-feather';
import { ThemeContext } from 'styled-components';
import { themeStrings, themes } from '../Theme';
import { ThemeInterface } from '../../interfaces/themeInterface';

export const ThemeSwitchButton = ({
  updateTheme,
}: {
  updateTheme: (theme: ThemeInterface) => void;
}) => {
  const theme = useContext(ThemeContext);
  if (!theme) return null;

  const switchTheme = () => {
    const setTo = theme.name === themeStrings.light ? themeStrings.dark : themeStrings.light;
    updateTheme(themes[setTo as keyof typeof themes]);
  };

  return (
    <S.ThemeSwitchButton onClick={() => switchTheme()}>
      {theme.name === themeStrings.light ? <Moon /> : <Sun />}
    </S.ThemeSwitchButton>
  );
};
